import { ReactNode, useEffect, useRef, useState } from "react";
import SideBar, { SideBarRef } from "./SideBar";
import Popup from "components/popup/Popup";

export default function Layout({ children }: { children: ReactNode }) {
    const sidebarRef = useRef<SideBarRef | null>(null);
    const [ready, setReady] = useState(false);

    useEffect(() => {
        const checkReady = () => {
            if (sidebarRef.current?.isReady()) {
                setReady(true);
            } else {
                setTimeout(checkReady, 10);
            }
        };
        checkReady();
    }, []);

    // 가로 스르롤 막기
    useEffect(() => {
        document.body.style.overflowX = "hidden";
    }, []);

    return (
        <div className="flex">
            <SideBar ref={sidebarRef} />
            {/* 사이드바가 렌더된 후에 children 렌더 */}
            {ready && <div className="flex-1 flex animate-fade-in overflow-hidden">{children}</div>}

            {/* 팝업 */}
            <Popup />
        </div>
    );
}
